import { Grid } from "@mui/material";
import { FormikProps } from "formik";
import CustomSelect from "@/components/CustomSelect";
import Input from "@/components/Input";
import { useRoleController } from "@/components/useRoleController";
import { RosTemplate } from "@/services";
import { getViewAs } from "@/utils/auth-storage";
import { TEMPLATE_TYPE_LIST } from "../../form-builder/form-builder-constant";

interface TemplateBasicReqFieldsProps {
  formik: FormikProps<RosTemplate>;
  prefillData?: unknown;
  readOnly?: boolean;
}

const TemplateBasicReqFields = ({
  formik,
  prefillData,
  readOnly = false,
}: TemplateBasicReqFieldsProps) => {
  const { hasUpdate: hasPeUpdate } = useRoleController(
    "Templates > Physical Exam (PE)"
  );
  const { hasUpdate: hasRosUpdate } = useRoleController(
    "Templates > Review of System (ROS)"
  );

  const viewAs = getViewAs();

  return (
    <Grid container spacing={2} mb={1}>
      <Grid item xs={2.5}>
        <CustomSelect
          label="Template Type"
          placeholder="Select Form Type"
          disableSortOptions
          options={TEMPLATE_TYPE_LIST.filter((item) => {
            if (
              (item.value === "PHYSICAL" || item.value === "HOME_CARE_PE") &&
              viewAs === "provider"
            )
              return hasPeUpdate;
            if (
              (item.value === "ROS" || item.value === "HOME_CARE_ROS") &&
              viewAs === "provider"
            )
              return hasRosUpdate;
            return true;
          })}
          value={formik.values?.templateTypes}
          readOnly={readOnly || !!prefillData}
          onChange={(val) => formik.setFieldValue("templateTypes", val)}
          error={formik.touched?.templateTypes && formik.errors?.templateTypes}
        />
      </Grid>

      <Grid item xs={6}>
        <Input
          label="Name Of Template"
          required
          textFieldProps={{
            disabled: readOnly,
            name: "templateName",
            value: formik.values.templateName,
            onChange: formik.handleChange,
            placeholder: "Enter Template Name",
          }}
          error={formik.touched?.templateName && formik.errors?.templateName}
        />
      </Grid>
    </Grid>
  );
};

export default TemplateBasicReqFields;
